export default __webpack_public_path__ + "static/media/about.d862e01b.jpg";